$(document).ready(function () {
  $('.carousel-img').flickity({
    cellAlign: 'left',
    groupCells: true,
    contain: true
  });
  /* Set all drawer elements to tabindex -1 by default on load */
  $('.sizeguide-drawer *').attr('tabindex', '-1');
})

function toggleIframeFullscreen() {
  const iframe = document.getElementById('myIframe');
  const isDesktop = window.innerWidth > 768; // Define desktop as wider than 768px
  if (isDesktop) {
    iframe?.setAttribute('allowfullscreen', '');
  } else {
    iframe?.removeAttribute('allowfullscreen');
  }
}

/* Run on page load and screen resize */
window.addEventListener('load', toggleIframeFullscreen);
window.addEventListener('resize', toggleIframeFullscreen);

/* Close Drawer */
$('.close-drawer').click(function () {
  closeDrawer();
});

$('.tab-content-inner:first').addClass('active');
$('.tab-link-inner:first').addClass('active');

$('.tab-link-inner').click(function () {
  var tab_id = $(this).attr('data-tab');
  $('.tab-link-inner').removeClass('active');
  $('.tab-content-inner').removeClass('active');
  $(this).addClass('active');
  $("#" + tab_id).addClass('active');
});

$('.measure-video .playicon').on('click', function () {
  var video = $(this).siblings("video")[0];
  if (video.paused) {
    $(this).removeClass('play').addClass('pause');
    video.play();
  } else {
    $(this).removeClass('pause').addClass('play');
    video.pause();
  }
});

$('.measure-video video').on('ended', function () {
  $(this).siblings('.playicon').removeClass('pause').addClass('play');
});

/* Stopping the video autoplay */
$('.measure-video video').each(function () {
  $(this).get(0).pause();
});

/* Trigger Play/Pause via Keyboard: Accessibility */
$('#-videoActionButton').on('keypress', function (event) {
  if (event.which === 13) {
    $(this).trigger('click');
  }
});

/* Close Size Guide Drawer Function */
function closeDrawer() {
  $('.sizeguide-drawer').removeClass("sizeguide-drawer-show").attr('tabindex', '-1');
  $('body').removeClass("hide-verticalscroll darkoverlay");
  // $('.shopify-section--header').removeClass("minuszindex");
  $('.announcement-fixed').removeClass("minuszindex");
  $('.ProductForm__AddToCart').removeClass("minuszindex2");
  $('.all-faq-card').removeClass("minuszindex2");
  $('.ColorSwatch').removeClass("minuszindex2");
  $('.stone-thumb-selected').removeClass("minuszindex2");
  $('.included-wrapper').removeClass("minuszindex2");
  $('.fixed-backdrop').removeClass("fixed-backdrop-show");
  $('.OptionSelector').attr('aria-hidden','true')
  $('body').addClass('is-rc-close')
  // Disable all elements inside drawer
  $('.sizeguide-drawer *').attr('tabindex', '-1');
  // Remove focus and return to trigger
  document.activeElement.blur();
  $('.custom-all-size-guide').focus();
}

/* Close Size Guide Drawer when user clicks outside of the drawer */
const section = $('.pdp-sizechart-wrapper');
const excludeButton = $('.custom-all-size-guide');
function handleOutsideClick() {
  closeDrawer();
}
$(document).on('click', function (event) {
  if (section.find('.sizeguide-drawer').hasClass('sizeguide-drawer-show') && !event.target.closest('.custom-all-size-guide')) {
    if (!section.is(event.target) && section.has(event.target).length === 0 &&
      !excludeButton.is(event.target) && excludeButton.has(event.target).length === 0) {
      handleOutsideClick();
    }
  }
});

/* Open Size Guide Drawer Function */
function openSizeDrawer() {
  $('.sizeguide-drawer').addClass("sizeguide-drawer-show").attr('tabindex', '0');
  $('body').addClass("hide-verticalscroll darkoverlay");
  $('.announcement-fixed').addClass("minuszindex");
  $('.ProductForm__AddToCart').addClass("minuszindex2");
  $('.all-faq-card').addClass("minuszindex2");
  $('.stackwith-card').addClass("minuszindex3");
  $('.ColorSwatch').addClass("minuszindex2");
  $('.stone-thumb-selected').addClass("minuszindex2");
  $('.included-wrapper').addClass("minuszindex2");
  $('.fixed-backdrop').addClass("fixed-backdrop-show");
  $('.OptionSelector').attr('aria-hidden','true')
  // Enable tabindex for focusable elements only
  $('.sizeguide-drawer').find('a, button').attr('tabindex', '0');
  // Focus first focusable element
  $('.sizeguide-drawer').find('a, button').first().focus();
  trapFocusInDrawer();
} 
/* Trap focus inside drawer */
function trapFocusInDrawer() {
  const drawer = $('.sizeguide-drawer');
  const focusableSelectors = 'a[href], button:not([disabled]), textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select';
  let focusableElements = drawer.find(focusableSelectors).filter(':visible');
  
  if (focusableElements.length === 0) return;

  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  drawer.off('keydown').on('keydown', function (e) {
    if (e.key === 'Tab') {
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  });
}